export enum Position {
  TOP = 'top',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  LEFT = 'left',
  CENTER = 'center',
}

export enum ToastType {
  ERROR = 'Error',
  SUCCESS = 'Success',
  INFO = 'Info',
}

export enum ToastAnimationShowType {
  FADE = 'fade',
  SLIDE = 'slide',
}

export enum StorageEnum {
  CompanyId = 'id',
  CompanyName = 'companyName',
  LibraryId = 'libraryId',
  AuditDesignation = 'auditDesignation',
  AuditCompanyName = 'auditCompanyName',
  GuestAudit = 'Guest',
}

export enum AddressStatus {
  PotentialCustomer = 'potentieller Kunde', // pick list item in address Kundenstatus
  Customer = 'Kunde',
}

export enum GuestEnum {
  AnonymousCompany = 'anonymous Company',
  GuestLibrary = 'QUIDT Digitalisierungstool Kompakt',
  GuestRoute = 'guest',

  AnonymousUserName = 'guest.anonymous.user',
  AnonymousUserPassword = '@quidt2024',

  AuditNameSeperator = '_',
}

export enum FavoriteAction {
  ADD,
  DELETE
}
export enum ButtonAction {
  INSERT='insert',
  EDIT='edit',
  NULL=''
}
export enum CompanyFilters {
  ALL = 0,
  COMPANY_WITH_AUDITS = 1,
  LAST_COMPANY = 2
}